export class MenuItem {
  id?: string;
  text?: string;
  icon?: string;
}
